// Shared registration instance
let serviceWorkerRegistration: ServiceWorkerRegistration | null = null;

export function getServiceWorkerRegistration(): ServiceWorkerRegistration | null {
  return serviceWorkerRegistration;
}

export function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) {
    console.warn('[ServiceWorker] Service Workers are not supported in this browser');
    return Promise.resolve(null);
  }

  return navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('[ServiceWorker] Service Worker registered with scope:', registration.scope);

      if (registration.active) {
        console.log('[ServiceWorker] Service Worker is already active');
        return registration;
      }

      return new Promise<ServiceWorkerRegistration>((resolve) => {
        registration.addEventListener('activate', () => {
          console.log('[ServiceWorker] Service Worker activated');
          resolve(registration);
        });
      });
    })
    .then((registration) => {
      serviceWorkerRegistration = registration;
      return registration;
    })
    .catch((error) => {
      console.error('[ServiceWorker] Service Worker registration failed:', error);
      serviceWorkerRegistration = null;
      return null;
    });
}

export function initializeServiceWorker(): Promise<void> {
  return registerServiceWorker()
    .then((registration) => {
      if (!registration) {
        console.error('[ServiceWorker] Failed to register service worker');
      }
    })
    .catch((error) => {
      console.error('[ServiceWorker] Failed to initialize service worker:', error);
    });
}
